import {
  getDepositInPublic,
  useGetDepositInPublic,
  useGetPrimaryPaymentMethodInPublic,
} from '@modusign/openapi-client-payment';
import { UseQueryOptions } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

export default function useDeposit<TError = Error>(
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof getDepositInPublic>>,
      TError,
      Awaited<ReturnType<typeof getDepositInPublic>> & { isPrimaryPaymentMethod: boolean }
    >,
    'select'
  >
) {
  const workspaceId = useWorkspaceId();
  const primaryPaymentMethod = useGetPrimaryPaymentMethodInPublic(workspaceId, {
    query: { suspense: options?.suspense },
  });

  return useGetDepositInPublic(workspaceId, {
    query: {
      ...options,
      select: (deposit) => ({
        ...deposit,
        isPrimaryPaymentMethod: deposit.id === primaryPaymentMethod.data?.paymentMethodReferenceId,
      }),
    },
  });
}
